import { useSelector } from 'react-redux'
import { getCurrentAccount } from 'auth/selectors'
import { addSeparators } from 'utils'
import { Currency, defaultCurrency } from './moneyHoc'

export const useCurrency = (): Currency => {
    const account = useSelector(getCurrentAccount)

    return {
        code: account?.currencyCode ?? defaultCurrency.code,
        symbol: account?.currencySymbol ?? defaultCurrency.symbol,
        position: account?.currencyPosition ?? defaultCurrency.position,
        decimalPoints: account?.currencyDecimalPoints ?? defaultCurrency.decimalPoints,
    }
}

export const useCreateFormatCurrencyString = () => {
    const account = useSelector(getCurrentAccount)

    return (amount: number | string | null): string => {
        if (amount === null) {
            return '-'
        }

        const symbol = account && account.currencySymbol ? account.currencySymbol : defaultCurrency.symbol
        const position = account && account.currencyPosition ? account.currencyPosition : defaultCurrency.position
        const decimalPoints = account?.currencyDecimalPoints || defaultCurrency.decimalPoints
        const formattedAmount = isNaN(Number(amount)) ? amount : addSeparators(amount, decimalPoints)
        return position === 'BEFORE' ? `${symbol} ${formattedAmount}` : `${formattedAmount} ${symbol}`
    }
}
